export default [
  {
    name: 'RM',
    code: 'MYR'
  },
  {
    name: 'USD',
    code: 'USD'
  }
]
